

export function isNull (val, replace) {
    if(val === null)
        return replace;

    return val;
}